import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialModule } from '@lockton-apps/material';

import { SelectorComponent } from './selector.component';
import { SearchFieldModule } from '../search-field';

@NgModule({
  imports: [CommonModule, MaterialModule, SearchFieldModule],
  declarations: [SelectorComponent],
  exports: [SelectorComponent],
})
export class SelectorModule {}
